<template>
  <b-form>
    <b-form-group label="Type of payment plan">
      <b-form-select
          v-model="plan.type"
          :options="planTypeOptions"
          :state="fieldValid('type')"
          :disabled="disabled"
      />
    </b-form-group>

    <b-form-group
        v-if="plan.type === 'add-on'"
        label="Which hubs"
    >
      <b-form-checkbox-group
          v-model="plan.hub_addons"
          :options="planHubAddonOptions"
          stacked
          :disabled="disabled"
      />
      <b-form-invalid-feedback :state="fieldValid('hub_addons')">
        {{ validation.hub_addons }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Pricing plan name">
      <b-form-input
          v-model="plan.name"
          :state="fieldValid('name')"
          autocomplete="off"
          :disabled="disabled"
      />
      <b-form-invalid-feedback :state="fieldValid('name')">
        {{ validation.name }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Pricing plan for">
      <b-form-select
          v-model="plan.company_type"
          :options="planCompanyTypeOptions"
          :state="fieldValid('company_type')"
          :disabled="disabled"
      />
      <b-form-invalid-feedback :state="fieldValid('company_type')">
        {{ validation.company_type }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Pricing plan rate">
      <b-form-select
          v-model="plan.rate"
          :options="planRateOptions"
          :state="fieldValid('rate')"
          :disabled="disabled"
      />
      <b-form-invalid-feedback :state="fieldValid('rate')">
        {{ validation.rate }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="plan.rate === 'paid'" label="Pricing plan rate amount">
      <b-input-group prepend="$">
        <b-form-input
            v-model="plan.amount"
            type="number"
            min="0"
            :state="fieldValid('amount')"
            :disabled="disabled"
        />
      </b-input-group>
      <b-form-invalid-feedback :state="fieldValid('amount')">
        {{ validation.amount }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group v-if="plan.type === 'membership'" label="Ability to add free access to certain hubs">
      <b-form-checkbox v-model="plan.is_hub_access" :disabled="disabled">
        Yes
      </b-form-checkbox>
    </b-form-group>

    <b-form-group
        v-if="plan.type === 'membership' && plan.is_hub_access"
        label="Which hubs"
    >
      <b-form-checkbox-group
          v-model="plan.hub_addons"
          :options="planHubAddonOptions"
          stacked
          :disabled="disabled"
      />
      <b-form-invalid-feedback :state="fieldValid('hub_addons')">
        {{ validation.hub_addons }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Display this plan in App">
      <b-form-checkbox v-model="plan.is_public" :disabled="disabled">
        Yes
      </b-form-checkbox>
    </b-form-group>

    <template v-if="plan.rate === 'paid'">
      <b-form-group label="Different rates by user type">
        <b-form-checkbox v-model="plan.is_rates_by_user" :disabled="disabled">
          Yes
        </b-form-checkbox>
      </b-form-group>
      <div v-if="plan.is_rates_by_user" style="padding: 15px; background: #f6f8fb; margin-bottom: 15px;">
        <div v-for="(user, key) in plan.rates_by_user" :key="key">
          <b-row>
            <b-form-group v-if="!disabled" style="align-self: flex-end; padding-left: 15px;">
              <b-button variant="danger" @click="() => removeUserRate(key)" style="height: 36px" >
                <b-icon-x/>
              </b-button>
            </b-form-group>
            <b-col>
              <b-form-group label="User type">
                <b-form-select
                    v-model="user.type"
                    :options="userTypeOptions"
                    :state="fieldValid(`rates_by_user.${key}.type`)"
                    :disabled="disabled"
                />
                <b-form-invalid-feedback :state="fieldValid(`rates_by_user.${key}.type`)">
                  {{ validation[`rates_by_user.${key}.type`] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Amount">
                <b-input-group prepend="$">
                  <b-form-input
                      v-model="user.amount"
                      type="number"
                      min="0"
                      :state="fieldValid(`rates_by_user.${key}.amount`)"
                      :disabled="disabled"
                  />
                </b-input-group>
                <b-form-invalid-feedback :state="fieldValid(`rates_by_user.${key}.amount`)">
                  {{ validation[`rates_by_user.${key}.amount`] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-btn
            v-if="!disabled"
            type="button"
            variant="secondary"
            @click="addUserRate"
        >
          Add user rate
        </b-btn>
      </div>

      <b-form-group label="Different rates by limits">
        <b-form-checkbox v-model="plan.is_rates_by_limit" :disabled="disabled">
          Yes
        </b-form-checkbox>
      </b-form-group>
      <div v-if="plan.is_rates_by_limit" style="padding: 15px; background: #f6f8fb; margin-bottom: 15px;">
        <div v-for="(limit, key) in plan.rates_by_limit" :key="key">
          <b-row>
            <b-form-group v-if="!disabled" style="align-self: flex-end; padding-left: 15px;">
              <b-button variant="danger" @click="() => removeLimitRate(key)" style="height: 36px">
                <b-icon-x/>
              </b-button>
            </b-form-group>
            <b-col>
              <b-form-group label="Limit type">
                <b-form-select
                    v-model="limit.type"
                    :options="limitTypeOptions"
                    :disabled="disabled"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="From">
                <b-form-input
                    v-model="limit.from"
                    type="number"
                    min="0"
                    :state="fieldValid(`rates_by_limit.${key}.from`)"
                    :disabled="disabled"
                />
                <b-form-invalid-feedback :state="fieldValid(`rates_by_limit.${key}.from`)">
                  {{ validation[`rates_by_limit.${key}.from`] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="To">
                <b-form-input
                    v-model="limit.to"
                    type="number"
                    min="0"
                    :state="fieldValid(`rates_by_limit.${key}.to`)"
                    :disabled="disabled"
                />
                <b-form-invalid-feedback :state="fieldValid(`rates_by_limit.${key}.to`)">
                  {{ validation[`rates_by_limit.${key}.to`] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Amount">
                <b-input-group prepend="$">
                  <b-form-input
                      v-model="limit.amount"
                      type="number"
                      min="0"
                      :state="fieldValid(`rates_by_limit.${key}.amount`)"
                      :disabled="disabled"
                  />
                </b-input-group>
                <b-form-invalid-feedback :state="fieldValid(`rates_by_limit.${key}.amount`)">
                  {{ validation[`rates_by_limit.${key}.amount`] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <b-btn
            v-if="!disabled"
            type="button"
            variant="secondary"
            @click="addLimitRate"
        >
          Add limit rate
        </b-btn>
      </div>
    </template>

    <template v-if="plan.type === 'membership'">
      <b-form-group label="Additional charges">
        <b-form-checkbox :checked="!plan.is_additional_charges" @input="val => plan.is_additional_charges = !val" :disabled="disabled">
          No additional charges
        </b-form-checkbox>
      </b-form-group>
      <div v-if="plan.is_additional_charges" style="padding: 15px; background: #f6f8fb; margin-bottom: 15px;">
        <b-row v-for="(charge, key) in additionalChargeTypes" :key="key">
          <b-col>
            <b-form-group label="Type">
              {{ charge.text }}
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Rate">
              <b-form-select
                  v-model="plan.additional_charges[charge.value].rate"
                  :options="additionalChargeRateOptions"
                  :state="fieldValid(`additional_charges.${charge.value}.rate`)"
                  :disabled="disabled"
              />
              <b-form-invalid-feedback :state="fieldValid(`additional_charges.${charge.value}.rate`)">
                {{ validation[`additional_charges.${charge.value}.rate`] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Amount">
              <b-input-group
                  :prepend="plan.additional_charges[charge.value].rate === 'fixed' ? '$' : null"
                  :append="plan.additional_charges[charge.value].rate === '%' ? '%' : null"
              >
                <b-form-input
                    v-model="plan.additional_charges[charge.value].amount"
                    type="number"
                    min="0"
                    :state="fieldValid(`additional_charges.${charge.value}.amount`)"
                    :disabled="disabled"
                />
              </b-input-group>
              <b-form-invalid-feedback :state="fieldValid(`additional_charges.${charge.value}.amount`)">
                {{ validation[`additional_charges.${charge.value}.amount`] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </template>

    <template v-if="plan.rate === 'paid'">
      <b-form-group label="Billing frequency">
        <b-form-select
            v-model="plan.billing_frequency"
            :options="billingFrequencyOptions"
            :state="fieldValid('billing_frequency')"
            :disabled="disabled"
        />
        <b-form-invalid-feedback :state="fieldValid('billing_recurrence')">
          {{ validation.billing_frequency }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group v-if="plan.billing_frequency === 'recurring'" label="Billing recurrence">
        <b-form-select
            v-model="plan.billing_recurrence"
            :options="billingRecurrenceOptions"
            :state="fieldValid('billing_recurrence')"
            :disabled="disabled"
        />
        <b-form-invalid-feedback :state="fieldValid('billing_recurrence')">
          {{ validation.billing_recurrence }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label="Free trial">
        <b-form-checkbox v-model="plan.is_free_trial" :disabled="disabled">
          Yes
        </b-form-checkbox>
      </b-form-group>
      <div v-if="plan.is_free_trial" style="padding: 15px; background: #f6f8fb; margin-bottom: 15px;">
        <b-row>
          <b-col>
            <b-form-group label="Length">
              <b-form-input
                  v-model="plan.free_trial_length"
                  type="number"
                  :state="fieldValid('free_trial_length')"
                  :disabled="disabled"
              />
              <b-form-invalid-feedback :state="fieldValid('free_trial_length')">
                {{ validation.free_trial_length }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Period">
              <b-form-select
                  v-model="plan.free_trial_period"
                  :options="freeTrialPeriodOptions"
                  :state="fieldValid('free_trial_period')"
                  :disabled="disabled"
              />
              <b-form-invalid-feedback :state="fieldValid('free_trial_period')">
                {{ validation.free_trial_period }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </template>

    <template v-if="plan.type === 'membership'">
      <b-form-group label="Set limit of active licenses">
        <b-form-checkbox v-model="plan.is_limit_licenses" :disabled="disabled">
          Yes
        </b-form-checkbox>
      </b-form-group>

      <template v-if="plan.is_limit_licenses">
        <b-form-group label="Number of active licenses included">
          <b-form-input
              v-model="plan.licenses_limit"
              type="number"
              min="0"
              :state="fieldValid('licenses_limit')"
              :disabled="disabled"
          />
          <b-form-invalid-feedback :state="fieldValid('licenses_limit')">
            {{ validation.licenses_limit }}
          </b-form-invalid-feedback>
        </b-form-group>

        <template v-if="plan.rate === 'paid'">
          <b-form-group label="Allow additional licenses">
            <b-form-checkbox v-model="plan.allow_extra_licenses" :disabled="disabled">
              Yes
            </b-form-checkbox>
          </b-form-group>

          <b-form-group v-if="plan.allow_extra_licenses" label="Price per each additional license">
            <b-input-group prepend="$">
              <b-form-input
                  v-model="plan.extra_license_price"
                  type="number"
                  min="0"
                  :state="fieldValid('extra_license_price')"
                  :disabled="disabled"
              />
            </b-input-group>
            <b-form-invalid-feedback :state="fieldValid('extra_license_price')">
              {{ validation.extra_license_price }}
            </b-form-invalid-feedback>
          </b-form-group>
        </template>
      </template>
    </template>
  </b-form>
</template>

<script>
export default {
  name: 'AdminPricingPlanForm',
  props: {
    value: {},
    validation: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      planTypeOptions: [
        {value: 'membership', text: 'Membership (access to platform)'},
        {value: 'add-on', text: 'For a hub (add-on to membership)'}
      ],
      planHubAddonOptions: [
        {value: 'data-tools', text: 'Data Tools'},
        {value: 'fulfillment-hub', text: 'Fulfillment Hub'}
      ],
      planRateOptions: [
        {value: 'paid', text: 'Paid'},
        {value: 'free', text: 'Free'}
      ],
      planCompanyTypeOptions: [
        {value: 'metrc', text: 'THC companies'},
        {value: 'non-metrc', text: 'Non-THC companies'},
      ],
      userTypeOptions: [
        {value: 'retail', text: 'Retailer'},
        {value: 'cultivator', text: 'Cultivator'},
        {value: 'manufacturer', text: 'Manufacturer'},
        {value: 'distributor', text: 'Distributor'}
      ],
      limitTypeOptions: [
        {value: 'brand', text: 'Brands'},
        //{value: 'license', text: 'Licenses'},
        //{value: 'state', text: 'States (Markets)'}
      ],
      additionalChargeTypes: [
        {value: 'order', text: 'Orders'},
        {value: 'reorder', text: 'Reorders'},
        {value: 'auction', text: 'Auctions'},
        {value: 'offer', text: 'Wanted Listing Offers'},
        {value: 'promoted_auction', text: 'Featured Auctions'},
        {value: 'fast_auction', text: 'Fast Auctions'},
        {value: 'reserve_auction', text: 'Reserve Price'},
        {value: 'buy_now_auction', text: 'Buy Now Price'},
      ],
      additionalChargeRateOptions: [
        {value: '%', text: '%'},
        {value: 'fixed', text: 'Fixed'}
      ],
      billingFrequencyOptions: [
        {value: 'one-time', text: 'One-time'},
        {value: 'recurring', text: 'Recurring'}
      ],
      billingRecurrenceOptions: [
        //week and 2-week options removed.
        //{value: 'week', text: 'Weekly'},
        //{value: '2-week', text: 'Biweekly'},
        {value: 'month', text: 'Monthly'},
        {value: 'quarter', text: 'Quarterly'},
        {value: 'year', text: 'Annually'},
      ],
      freeTrialPeriodOptions: [
        {value: 'day', text: 'Days'},
        {value: 'week', text: 'Weeks'},
        {value: 'month', text: 'Months'}
      ]
    }
  },
  methods: {
    addUserRate() {
      this.plan.rates_by_user.push({
        type: 'retail',
        amount: 0
      })
    },
    removeUserRate(index) {
      this.plan.rates_by_user.splice(index, 1);
    },
    addLimitRate() {
      this.plan.rates_by_limit.push({
        type: 'brand',
        from: '',
        to: '',
        amount: 0
      })
    },
    removeLimitRate(index) {
      this.plan.rates_by_limit.splice(index, 1);
    },
    fieldValid(field) {
      return typeof this.validation[field] !== "undefined" && this.validation[field].length > 0 ? false : null;
    }
  },
  computed: {
    plan: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>
